import '../styles/about-styles.css'


function LoadAbout() {

    return (
        <div className="container" id="about">
            <div>
                <h2>A Fusion of Domain Expertise and AI Mastery</h2>
                <p>Our strength lies at the intersection of deep industry knowledge and cutting-edge artificial intelligence.</p>
            </div>

            <div className='cards'>
                <div className='card'>
                    <h3>Hypercharged AI</h3>
                    <p>We specialize in low-data models, AI-driven data cleansing, and advanced analytics across video, image, audio, and text. Our algorithms are designed for constant, automated improvement.</p>
                </div>
                
                <div className='card'>
                    <h3>Domain-Adapted AI</h3>
                    <p>With entrepreneurial roots in Data Science, Retail, FoodTech, and Climate Tech, we leverage subject matter expertise to build high-value, practical AI products that truly fit your world.</p>
                </div>

                <div className='card'>
                    <h3>Custom-Built AI</h3>
                    <p>Our solutions are tailor-made for your unique data and infrastructure, deployable on the cloud, on-premises, or at the edge for maximum flexibility and performance.</p>
                </div>
            </div>
        </div>
    )
}

export default LoadAbout;